export default __webpack_public_path__ + "static/media/logo240.8a79d804.png";